<template>
    <div v-bind:data-test-role="`testRole.property.${label}`">
        <pc-loader
            class="w-100"
            small
            v-bind:loading="isLoading">
            <pc-input
                v-bind="displayInputBinder"
                ref="input"
                v-on:update:model-value="onTextInput"
                v-on:help-clicked="onHelpClicked($event)">
                <template
                    v-if="canShow || canEdit"
                    v-slot:manualAppend="">
                    <button
                        v-if="canShow || isEditing"
                        class="btn btn-secondary input-group-text"
                        name="show-button"
                        v-on:click="onShowClicked">
                        {{ isShowing ? hideLabel : showLabel }}
                    </button>
                    <button
                        v-if="canEdit"
                        class="btn btn-secondary input-group-text"
                        name="edit-button"
                        v-on:click="onEditClicked">
                        {{ isEditing ? cancelLabel : editLabel }}
                    </button>
                </template>
            </pc-input>
        </pc-loader>
    </div>
</template>
<script>
    import base from "Components/_inputBase.vue";
    import pcInput from "Components/pc-input.vue";
    import { mapI18n } from "Util/i18n";
    import { KEYS, NAMESPACE } from "./i18n/sensitiveInput.i18n";

    export default {
        components: { pcInput },
        extends: base,
        props: {
            canShow: { type: Boolean, required: false, default: true },
            canEdit: { type: Boolean, required: false, default: true }
        },
        emits: ["plaintextRequested", "help-clicked"],
        data: function () {
            return {
                isShowing: false,
                isEditing: false,
                isLoading: false,
                hasPlaintext: false,
                plainTextValue: null,
                obfuscatedValue: this.modelValue
            };
        },
        computed: {
            ...mapI18n(
                {
                    ...KEYS
                },
                NAMESPACE
            ),
            showingPlaintext() {
                return this.isShowing && !this.isEditing;
            },
            displayInputBinder() {
                return {
                    // Manually binding value instead of using v-model so that clicking "show"
                    // doesn't display the "Unsaved Changes" and confuse users
                    modelValue: this.showingPlaintext ? this.plainTextValue : this.modelValue,
                    type: this.isShowing ? "text" : "password",
                    autocomplete: this.isShowing ? "" : "new-password",
                    key: this.isShowing ? `${this.inputId}-revealed` : `${this.inputId}-hidden`,
                    id: this.inputId,
                    required: this.required,
                    validator: this.validator,
                    label: this.label,
                    readonly: !this.isEditing,
                    hasManualAppend: this.canShow || this.canEdit,
                    showHelp: this.showHelp
                };
            }
        },
        watch: {
            isShowing(value) {
                this.isShowing = value;
            }
        },
        methods: {
            // Callback for when the plaintext value was retrieved successfully
            onPlaintextValueSet(value) {
                this.hasPlaintext = true;
                this.plainTextValue = value;
                this.isShowing = true;
                this.isLoading = false;
            },
            // Callback for when the plaintext value could not be retrieved for any reason
            onPlaintextRequestCancelled() {
                this.isLoading = false;
            },
            async onShowClicked() {
                if (this.isShowing) {
                    this.isShowing = false;
                } else if (this.hasPlaintext || this.isEditing) {
                    this.isShowing = true;
                } else {
                    this.isLoading = true;
                    this.$emit(
                        "plaintextRequested",
                        this.onPlaintextValueSet.bind(this),
                        this.onPlaintextRequestCancelled.bind(this)
                    );
                }
            },
            async onEditClicked() {
                this.isShowing = false;
                if (this.isEditing) {
                    this.internalValue = this.obfuscatedValue;
                    this.isEditing = false;
                } else {
                    this.internalValue = "";
                    this.isEditing = true;
                }
            },
            onTextInput(value) {
                if (!this.showingPlaintext) {
                    this.internalValue = value;
                }
            },
            onHelpClicked(event) {
                this.$emit("help-clicked", event);
            }
        }
    };
</script>
